import intl from 'react-intl-universal';
export default function responseMessage(response, scene) {
  const prefixResponse = {};
  switch (scene) {
    case 'zt':
      switch (response.status) {
        case -16772:
          prefixResponse.message = intl.get('SERVICE.NO.PASSPORT');
          prefixResponse.msg = intl.get('SERVICE.NO.PASSPORT');
          break;
        default:
      }
      return { ...response, ...prefixResponse };
    case 'xiGua':
      return { ...response, ...prefixResponse };
    default:
      return response;
  }
}
